import { useEffect, useState } from "react";

export const toMs = (iso) => {
    const time = iso ? new Date(iso).getTime() : NaN;
    return Number.isNaN(time) ? null : time;
};

// "47s", "1m 52s", "1h 04m".
export const formatDuration = (ms) => {
    const seconds = Math.max(0, Math.round(ms / 1000));
    if (seconds < 60) {
        return `${seconds}s`;
    }
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
        return `${minutes}m ${String(seconds % 60).padStart(2, "0")}s`;
    }
    return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, "0")}m`;
};

// The current time, refreshed every second while `ticking` so elapsed times move.
export const useNow = (ticking) => {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        if (!ticking) {
            return undefined;
        }
        setNow(Date.now());
        const timer = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(timer);
    }, [ticking]);
    return now;
};
